var sprintf = require('sprintf-js').sprintf;
var AppConfig = require('../config.json');

export function createReducer(initialState, reducerMap) {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];

    return reducer ? reducer(state, action.payload) : state;
  };
}

export function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export const beautifyPrice = price => {
	return parseFloat(price.replace(',','.')).toFixed(2).toString().split('.').join(',<sup>')+'</sup>';
}

export function cacheBust() {
  return "?cachebust="+Math.round(new Date().getTime() / 1000);
}

export function parseJSON(response) {
  return response.json();
}


export function checkInsurance(label) {
  var str = label.toLowerCase();
  if(str==='versicherung' || str==='versicherungen' || str==='versicherung wg') {
    return true;
  }
  return false;
}

export function typeOfInsurance(label) {
  var str = label.toLowerCase();
  if(str==='versicherung wg') {
    return "wg";
  }
  return "std";
}


export function getPaymentGroupLabel(choice) {
  var purchaseChoices = [];
  if (choice.group === 'financing' || choice.group === 'payever') {
    return {
      label: AppConfig.payments.abbr[choice.id],
      subline: AppConfig.payments.sublines[choice.id]
    };
  } else if (choice.group === 'purchase') {
    for (var i = 0; i < choice.data.length; i++) {
      if (AppConfig.payments.abbr.hasOwnProperty(choice.data[i].type)) {
        purchaseChoices.push(AppConfig.payments.abbr[choice.data[i].type]);
      }
    }
    return {
      label: AppConfig.payments.abbr[choice.id],
      subline: sprintf(
        AppConfig.payments.sublines[choice.id],
        purchaseChoices.join(' oder ')
      )
    };
  }
}

export function getPayeverChosen(details) {
  return sprintf(
    AppConfig.payments.options.payever.chosen,
    details.laufzeit
  )
}

export function getPaymentOptionsLabel(type, choice) {
  if (type === 'financing' || type === 'payever') {
    return {
      label: sprintf(AppConfig.payments.options[type].label, choice.runtime),
      subline: sprintf(
        AppConfig.payments.options[type].subline,
        parseFloat(choice.price.replace(',', '.')).toFixed(2).toString().replace('.', ',')
      )
    };
  } else if (type === 'purchase') {
    if (choice.type === 'sf') {
      return {
        label: sprintf(
          AppConfig.payments.options.payever.label,
          AppConfig.payments.abbr[choice.type]
        ),
        subline: sprintf(
          AppConfig.payments.options.payever.subline,
          parseFloat(choice.price.replace(',', '.')).toFixed(2).toString().replace('.', ',')
        )
      };
    }
    return {
      label: sprintf(
        AppConfig.payments.options[type].label,
        AppConfig.payments.abbr[choice.type]
      ),
      subline: sprintf(
        AppConfig.payments.options[type].subline,
        parseFloat(choice.price.replace(',', '.')).toFixed(2).toString().replace('.', ',')
      )
    };
  }
}

export function getPaymentOptionsLabelFinishView(type, choice) {
  if (type === 'financing') {
    return {
      label: sprintf(
        AppConfig.payments.optionsfinish[type].label,
        choice.runtime
      ),
      subline: sprintf(
        AppConfig.payments.optionsfinish[type].subline,
        choice.price.replace('.', ',')
      )
    };
  } else if (type === 'payever') {
    return {
      label: sprintf(
        AppConfig.payments.optionsfinish[type].label,
        AppConfig.payments.abbr[choice.type]
      ),
      subline: sprintf(
        AppConfig.payments.optionsfinish[type].subline,
        choice.price.replace('.', ',')
      )
    };
  } else if (type === 'purchase') {
    return {
      label: sprintf(
        AppConfig.payments.optionsfinish[type].label,
        AppConfig.payments.abbr[choice.type]
      ),
      subline: sprintf(
        AppConfig.payments.optionsfinish[type].subline,
        choice.price.replace('.', ',')
      )
    };
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js